import React from "react";
import "./Footer.css";
import footerBuilding from "../assets/footer-building.jpg";

const Footer = () => {
  return (
    <footer
      className="footer"
      id="footer-left"
      style={{ backgroundImage: `url(${footerBuilding})` }}
    >
      <div className="footer-top">
        <div id="contact-form-left">
          <h2 class="footer-h2">Kontakt</h2>
          <h1 class="footer-h1">Jesteśmy do twojej dyspozycji</h1>
          <div className="footer-contact-details">
            <p className="footer-contact-line footer-contact-name">EKSELOWE.PL</p>
            <p className="footer-contact-line">Roździeńska 41, 40-382 Katowice</p>
            <p className="footer-contact-line">NIP: 648-269-10-22</p>
            <p className="footer-contact-line">REGON: 362912930</p>
            <p className="footer-contact-line">
              <a href="tel:+48570301600">+48 570-301-600</a>
            </p>
            <p className="footer-contact-line">
              <a href="mailto:kontakt@ekselowe.pl">kontakt@ekselowe.pl</a>
            </p>
          </div>
        </div>

        <div id="footer-map-container">
          <iframe
            title="Ekselowe.pl — lokalizacja"
            className="footer-map"
            src="https://maps.google.com/maps?q=Rozdzie%C5%84ska%2041%2C%2040-382%20Katowice&t=&z=15&ie=UTF8&iwloc=&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
